export default __webpack_public_path__ + "static/emp-icn15-a53dc16c5d6868369f7c63c52f40c694.png";